document.addEventListener('DOMContentLoaded', function () {

  let body = document.querySelector('body');
  if(body)
  {
    body.addEventListener('click', function(e){
      if(e.target.closest('.boost-pfs-filter-option-item'))
      {
        let productGrid = document.querySelector('.product-grid > ul');
        if(productGrid)
        {
          if(!isElementInViewport(productGrid))
          {
            productGrid.scrollIntoView();
            let stickyHeader = document.getElementById('shopify-section-header');
            console.log(stickyHeader);
            stickyHeaderBoundingRect = stickyHeader.getBoundingClientRect();
            console.log(stickyHeaderBoundingRect);
            if(stickyHeaderBoundingRect.height)
            {
              console.log('scrolling further...'+stickyHeaderBoundingRect.height)
              window.scrollBy(0, (stickyHeaderBoundingRect.height * -1));
            }
          }
        }
      }

      console.log('body click')

      if(body.classList.contains('boost-sd__sticky-opening'))
      {
        if(e.target.classList.contains('btn-close-sidebar') || (!e.target.closest('#boost-sd_filter-tree-mobile') && ( (e.target.classList.contains('boost-sd__filter-tree-toggle-button')) || e.target.classList.contains('boost-sd__toolbar'))))
        {
          let closeBtn = document.getElementById('boost-sd__filter-tree-toggle-button');
          closeBtn.click();
        }
        else
        {
          console.log('.closest item is filter tree mobile OR target contained the filter button');
          console.log(e.target);
        }
      }
      else
      {
        console.log('body doesnt contain our class')
      }
    });
  }
  
  const mobileSearchToggle = document.querySelectorAll('.toggle-mobile-search');
  if(mobileSearchToggle)
  {
    mobileSearchToggle.forEach((mobileSearchToggleBtn) => {
      mobileSearchToggleBtn.addEventListener('click',function(){
      let mobileSearch = document.querySelector('.main-header form.search');
      if(mobileSearch)
      {
        mobileSearch.classList.toggle('active');
      }
    });
    });
  }
  const menuToggles = document.querySelectorAll('.trigger-sidebar-toggle');
  if(menuToggles){
    menuToggles.forEach((menuToggle) => {
      menuToggle.addEventListener('click',function(){
        const realMenuToggle = document.querySelector('.sidebar-toggle-control');
        realMenuToggle.click();
      });
    });
  }
  const liveChatButtons = document.querySelectorAll('[href="#liveChat"]');
  if(liveChatButtons)
  {
    liveChatButtons.forEach((chatButton) => {
      chatButton.addEventListener('click',function(e){
        e.preventDefault();
        window.LiveChatWidget.call('maximize');
        return false;
      });
    });
  }

  const deliveryButtons = document.querySelectorAll('[href="#deliveryPopup"]');
  const exchangeButtons = document.querySelectorAll('[href="#exchangePopup"]');
  if(deliveryButtons)
  {
    deliveryButtons.forEach((deliveryButton) => {
       deliveryButton.addEventListener('click', function(e){
        const modal = document.querySelector('#PopupModal-Delivery');
        if (modal) modal.show(deliveryButton);
      });
    });
  }

  if(exchangeButtons)
  {
    exchangeButtons.forEach((exchangeButton) => {
       exchangeButton.addEventListener('click', function(e){
        const modal = document.querySelector('#PopupModal-Exchanges');
        if (modal) modal.show(exchangeButton);
      });
    });
  }
  
  const swiperSelectors = document.querySelectorAll('.swiper');
  if(swiperSelectors)
  {
    swiperSelectors.forEach((swiperElement) => {
      const options = {
        loop: true,
        navigation: false,
        pagination:false,
        centerInsufficientSlides:true,
        centeredSlides:true,
        autoplay: {
          delay: 8000,
          disableOnInteraction: true
        },
        breakpoints: {
          320: {
            allowTouchMove: true
          },
          1000: {
            allowTouchMove: false
          }
        }
      };

      if(swiperElement.getAttribute('data-slides') && parseInt(swiperElement.getAttribute('data-slides')))
      {
        options.slidesPerView=parseInt(swiperElement.getAttribute('data-slides'));
      }
      
       if(swiperElement.getAttribute('data-mobile-slides') && parseInt(swiperElement.getAttribute('data-mobile-slides')))
        {
          var slidesPerView=1;
          if(parseInt(swiperElement.getAttribute('data-slides')))
             {
              slidesPerView = parseInt(swiperElement.getAttribute('data-slides'));
             }
          var mobileSlidesPerView = parseInt(swiperElement.getAttribute('data-mobile-slides'));
          options.breakpoints[320].slidesPerView = mobileSlidesPerView;
          options.breakpoints[1000].slidesPerView = slidesPerView;
        }

      if(swiperElement.getAttribute('data-loop') && swiperElement.getAttribute('data-loop') == "false")
      {
          options.breakpoints[1000]=false;
      }

       if(swiperElement.getAttribute('data-autoplay') && swiperElement.getAttribute('data-autoplay') == "false")
       {
         options.autoplay=false;
       }

      if(swiperElement.getAttribute('data-navigation') && swiperElement.getAttribute('data-navigation') == "true")
      {
        options.navigation=true;
      }
      else if(swiperElement.getAttribute('data-navigation') && swiperElement.getAttribute('data-navigation') == "custom")
      {
        options.navigation ={
          nextEl:  swiperElement.getAttribute('data-navigation-next'),
          prevEl:  swiperElement.getAttribute('data-navigation-prev')
        };
      }

      if(swiperElement.getAttribute('data-pagination') && swiperElement.getAttribute('data-pagination') == "true")
      {
        options.pagination={
    el: '.swiper-pagination',
    type: 'bullets',
  };
      }

      if(swiperElement.getAttribute('data-duration'))
      {
        var duration = parseInt(swiperElement.getAttribute('data-duration'));
        duration=duration*1000;
        options.autoplay.delay = duration;
      }
      const swiper = new Swiper(swiperElement, options);
    });
  }

  //const swiper = new Swiper('.swiper', {
  // Optional parameters
  //loop: true,
  //centerInsufficientSlides:true,
  //centeredSlides:true,
  // Navigation arrows
  //navigation: {
  //  nextEl: '.swiper-next-custom',
  //  prevEl: '.swiper-prev-custom',
  //},
  //});

let items = document.querySelector(".header__inline-menu").querySelectorAll("details");
items.forEach(item => {
  item.addEventListener("mouseover", () => {
    item.setAttribute("open", true);
    item.querySelector("ul").addEventListener("mouseleave", () => {
      item.removeAttribute("open");
    });
  item.addEventListener("mouseleave", () => {
    item.removeAttribute("open");
  });
});

});
}, false);

function isElementInViewport (el) {

    // Special bonus for those using jQuery
    if (typeof jQuery === "function" && el instanceof jQuery) {
        el = el[0];
    }

    var rect = el.getBoundingClientRect();

    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && /* or $(window).height() */
        rect.right <= (window.innerWidth || document.documentElement.clientWidth) /* or $(window).width() */
    );
}

function gcLaunchPopUp(popupId)
{
  let popup = document.getElementById(popupId);
  if(popup)
  {
   popup.showModal(); 
  }
}

  function gcShouldShowPopup(popupId)
  {
    if(gcGetCookie('gc_popup_'+popupId) !== 'dismissed' || 1==1)
    {
      let myTimeout = setTimeout(gcLaunchPopUp, 2000, popupId);
    } 
  }

  function gcDismissPopup(popupId)
  {
    let popup = document.getElementById(popupId);
    if(popup)
    {
     popup.close();
    }
    gcSetCookie('gc_popup_'+popupId, 'dismissed', 0);
  }
  
  function gcGetCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for(let i = 0; i <ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

function gcSetCookie(cname, cvalue, exdays) 
{
  if(exdays == 0)
  {
  document.cookie = cname + "=" + cvalue + "; path=/";
  }
  else
  {
  const d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  let expires = "expires="+ d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }
}

document.addEventListener('DOMContentLoaded',function(){
  let dialogClose = document.querySelectorAll('.close-modal');
  if(dialogClose)
  {
    dialogClose.forEach((btn) => {
      btn.addEventListener('click',function(){
        let containerDialog = this.closest('dialog');
        if(containerDialog)
        {
          gcDismissPopup(containerDialog.getAttribute('id'));
        }
      });  
    });
  }
});

